'use strict';

exports.__esModule = true;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _logoDark = require('../../src/assets/logo-dark.svg');

var _logoDark2 = _interopRequireDefault(_logoDark);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _loginComponent = require('login-component');

var _reactRedux = require('react-redux');

var _redux = require('redux');

var _widgetActions = require('../actions/widget-actions');

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = typeof navigator !== 'undefined' && navigator.languages || ['en'],
    locale = _ref[0];

var _locale$split = locale.split('-'),
    localeBase = _locale$split[0];

var lang = require('react-intl/locale-data/' + localeBase);
var messages = void 0;

try {
	messages = require('../../src/lang/' + localeBase + '.json');
} catch (error) {
	messages = require('../../src/lang/en.json');
}

(0, _reactIntl.addLocaleData)(lang);

var _ref2 = _react2.default.createElement('img', { src: _logoDark2.default });

var _ref3 = _react2.default.createElement(
	'h1',
	null,
	'Sign In'
);

var _ref4 = _react2.default.createElement(
	'p',
	null,
	'With your Doctify Account'
);

var LoginWidget = function LoginWidget(props) {
	if (!props.widget) {
		throw new Error('Missing one reducer!');
	}

	if (props.widget.redirect && (typeof window === 'undefined' ? 'undefined' : (0, _typeof3.default)(window)) !== undefined && props.location.query) {
		var query = props.location.query;

		window.location.href = query.redirect_uri + '?code=' + props.widget.token + '&state=' + query.state;
	}

	return _react2.default.createElement(
		_reactIntl.IntlProvider,
		{ locale: localeBase, messages: messages },
		_react2.default.createElement(
			'div',
			{ className: _style2.default.pageContainer },
			_react2.default.createElement(
				'div',
				{ className: '' + _style2.default.container },
				_react2.default.createElement(
					'div',
					{ className: _style2.default.header },
					_ref2,
					_ref3,
					_ref4
				),
				_react2.default.createElement(_loginComponent.LoginComponent, (0, _extends3.default)({}, props.widgetActions, props.widget, {
					alternateButtonText: 'Next',
					disableLinks: true,
					login: function login(auth) {
						return props.widgetActions.login((0, _extends3.default)({}, auth, {
							client_id: props.location && props.location.query && props.location.query.client_id
						}), {
							/**
       	IMPORTANT: this will need to be updated when we switch to use the bot in real environment
       **/
							baseUrl: 'https://testing.doctify.co.uk',
							xhrAdapter: _axios2.default
						});
					}
				})),
				props.widget && props.widget.serverError && _react2.default.createElement(
					'div',
					{ className: _style2.default.serverErrorHolder },
					_react2.default.createElement(
						'span',
						{ className: _style2.default.serverError },
						props.widget.serverError
					)
				)
			)
		)
	);
};

LoginWidget.propTypes = {
	location: require('react').PropTypes.object,
	widget: require('react').PropTypes.shape({
		location: require('react').PropTypes.object,
		redirect: require('react').PropTypes.any,
		token: require('react').PropTypes.any,
		serverError: require('react').PropTypes.any
	}).isRequired,
	widgetActions: require('react').PropTypes.shape({
		login: require('react').PropTypes.func.isRequired
	}).isRequired
};
LoginWidget.displayName = 'LoginWidget';

LoginWidget.defaultProps = {};

var mapStateToProps = function mapStateToProps(state) {
	return {
		widget: state.loginWidget.widget
	};
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	return {
		widgetActions: (0, _redux.bindActionCreators)(_widgetActions.widgetActions, dispatch)
	};
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(LoginWidget);